var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.481 4.48 0 10 0C15.53 0 20 4.481 20 10C20 15.521 15.53 20 10 20C4.48 20 0 15.521 0 10ZM9.12 6.21C9.12 5.731 9.52 5.33 10 5.33C10.48 5.33 10.87 5.731 10.87 6.21V10.63C10.87 11.111 10.48 11.5 10 11.5C9.52 11.5 9.12 11.111 9.12 10.63V6.21ZM10.01 14.681C9.52 14.681 9.13 14.281 9.13 13.801C9.13 13.321 9.52 12.931 10 12.931C10.49 12.931 10.88 13.321 10.88 13.801C10.88 14.281 10.49 14.681 10.01 14.681Z",
    fill: "#14537B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNotification);
export default __webpack_public_path__ + "static/media/InfoNotification.10949e16e2758c6bc08e279db8f24b1e.svg";
export { ForwardRef as ReactComponent };